export default {
  namespaced: true,

  state: {
    loading: false,
  },

  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
  },

  actions: {
    showLoading({ commit }) {
      commit("setLoading", true);
    },
    hideLoading({ commit }) {
      commit("setLoading", false);
    },
  },

  getters: {
    isLoading: (state) => state.loading,
  },
};
